// index.tsx
import { Redirect } from 'expo-router'

const Index = () => {
  return <Redirect href="/" />
}

export default Index
